import { LadeskChatAdditionalConfig } from '@bcf-vanilla-ui-ts-v1/shared/ladesk/ladesk-config.types';

export const ladeskChatAdditionalConfig: LadeskChatAdditionalConfig = {
  extraUserDetailsFields: { DOB: 'birthDate' }
};
